import './styles.css';
import React, { memo } from 'react';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
/**
 * エラー表示の実装
 */
const ErrorPage = memo(() => {
    return (
        <>
            <Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
                extra={
                    <Button type="primary">
                        <Link to="buy">Back</Link>
                    </Button>
                }
            />
            {/* <div className='error-page' >
                <span style={{ ...fonts.regular, whiteSpace: 'pre-wrap', color: colorText({}) }}>
                    404 Not Found
                </span>
            </div> */}
        </>
    );
});

export default ErrorPage;
